import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isProjectsDropdownOpen, setIsProjectsDropdownOpen] = useState(false);
  const location = useLocation();

  // Lista de proyectos para el submenú
  const projectsMenu = [
    { 
      id: 1, 
      title: 'Instalación Geomembrana (ECD)', 
      location: 'Ewarthon, Jamaica',
      year: '2022',
      thumbnail: '/images/fotos/otros/Rever_3.webp'
    },
    { 
      id: 2, 
      title: 'Instalación Geomembrana (EHP)', 
      location: 'Ewarthon, Jamaica',
      year: '2022',
      thumbnail: '/images/fotos/windalco2/windalco2_1.jpg'
    },
    { 
      id: 3, 
      title: 'Instalación Geomembrana (EHP)', 
      location: 'Ewarthon, Jamaica',
      year: '2023',
      thumbnail: '/images/fotos/windalco1/Windalco1_1.jpg'
    },
    { 
      id: 4, 
      title: 'Trabajos de Obra Mecánica', 
      location: 'Clarendon, Jamaica',
      year: '2022',
      thumbnail: '/images/fotos/otros/Rever_11.webp'
    },
    { 
      id: 5, 
      title: 'Instalación de Geomembrana', 
      location: 'Clarendon, Jamaica',
      year: '2024',
      thumbnail: '/images/fotos/jamalcoLinner/jamalcoLinner_10.jpg'
    },
    { 
      id: 6, 
      title: 'Construcción Edificio Turbina 45MW', 
      location: 'Clarendon, Jamaica',
      year: '2025',
      thumbnail: '/images/fotos/otros/Rever_13.webp'
    },
    { 
      id: 7, 
      title: 'Servicio de Topografía', 
      location: 'Clarendon, Jamaica',
      year: '2025',
      thumbnail: '/images/fotos/otros/Rever_24.webp'
    },
    { 
      id: 8, 
      title: 'Condensate Cooling Pond', 
      location: 'Clarendon, Jamaica',
      year: '2026',
      thumbnail: '/images/fotos/windalco3/windalco_1.jpeg'
    },
    { 
      id: 9, 
      title: 'Above Ground Storage Containment', 
      location: 'Jamaica',
      year: '2026',
      thumbnail: '/images/fotos/nuevas_2026/nuevas2026_31.jpeg'
    },
    {
      id: 10,
      title: '45 MW Steam Turbine Generator',
      year: 2026,
      thumbnail: '/images/fotos/steamTurbineGenerator/steamGenerator_3.JPG'
    }
  ];

  useEffect(() => {
    let scrollTimeout = null;

    const handleScroll = () => {
      if (scrollTimeout) {
        window.cancelAnimationFrame(scrollTimeout);
      }
      
      scrollTimeout = window.requestAnimationFrame(() => {
        setIsScrolled(window.scrollY > 50);
      });
    };

    // Cerrar dropdown al hacer scroll
    const handleScrollClose = () => {
      setIsProjectsDropdownOpen(false);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('scroll', handleScrollClose);
    handleScroll(); // Check initial scroll

    // Add loaded class for initial animations
    document.body.classList.add('loaded');

    // Cerrar dropdown al hacer click fuera
    const handleClickOutside = (e) => {
      if (!e.target.closest('.projects-dropdown-container')) {
        setIsProjectsDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScrollClose);
      document.removeEventListener('click', handleClickOutside);
      if (scrollTimeout) {
        window.cancelAnimationFrame(scrollTimeout);
      }
    };
  }, []);

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  const handleProjectsDropdown = (e) => {
    e.preventDefault();
    setIsProjectsDropdownOpen(!isProjectsDropdownOpen);
  };

  const scrollToProject = (projectId) => {
    setIsProjectsDropdownOpen(false);
    // Si estamos en la página de proyectos, hacer scroll al proyecto
    if (location.pathname === '/proyectos') {
      setTimeout(() => {
        const projectElement = document.querySelector(`[data-project-id="${projectId}"]`);
        if (projectElement) {
          projectElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  };

  return (
    <>
      {/* Navigation Bar */}
      <div className="header-container">
        {/* Logo section */}
        <div className="logo-section">
          <img src="/assets/nuevo_logo.png" alt="Logo" className="logo" />
        </div>
        
        <nav className={`nav ${isScrolled ? 'scrolled' : ''}`}>
          {/* Navigation Menu */}
          <div className="nav-menu">
            <Link 
              to="/" 
              className={`nav-link ${isActiveLink('/') ? 'router-link-active' : ''}`}
            >
              Inicio
            </Link>
            <Link 
              to="/quienes-somos" 
              className={`nav-link ${isActiveLink('/quienes-somos') ? 'router-link-active' : ''}`}
            >
              ¿Quiénes somos?
            </Link>
            <Link 
              to="/negocios" 
              className={`nav-link ${isActiveLink('/negocios') ? 'router-link-active' : ''}`}
            >
              Servicios
            </Link>
            
            {/* Proyectos con Dropdown */}
            <div className="projects-dropdown-container">
              <Link 
                to="/proyectos" 
                className={`nav-link projects-main-link ${isActiveLink('/proyectos') ? 'router-link-active' : ''}`}
                onClick={handleProjectsDropdown}
              >
                Proyectos
                <svg 
                  className={`dropdown-arrow ${isProjectsDropdownOpen ? 'rotated' : ''}`}
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 24 24" 
                  width="16" 
                  height="16"
                >
                  <path fill="currentColor" d="M7 10l5 5 5-5z"/>
                </svg>
              </Link>
              
              {/* Dropdown Menu */}
              <div className={`projects-dropdown ${isProjectsDropdownOpen ? 'open' : ''}`}>
                <div className="dropdown-header">
                  <span>Proyectos Realizados</span>
                </div>
                <div className="dropdown-content">
                  {projectsMenu.map((project) => (
                    <Link
                      key={project.id}
                      to="/proyectos"
                      className="dropdown-item"
                      onClick={() => scrollToProject(project.id)}
                    >
                      <div className="project-thumbnail">
                        <img 
                          src={project.thumbnail} 
                          alt={project.title}
                          onError={(e) => {
                            e.target.src = 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=80&h=60&fit=crop&auto=format';
                            e.target.style.opacity = '0.7';
                          }}
                        />
                      </div>
                      <div className="project-info">
                        <span className="project-title">{project.title}</span>
                        <span className="project-location">{project.location}</span>
                      </div>
                      <span className="project-year">{project.year}</span>
                    </Link>
                  ))}
                </div>
                <div className="dropdown-footer">
                  <Link to="/proyectos" className="view-all-projects">
                    Ver todos los proyectos
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                      <path fill="currentColor" d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z"/>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>

                        <Link 
              to="/gestion" 
              className={`nav-link ${isActiveLink('/gestion') ? 'router-link-active' : ''}`}
            >
              Gestión
            </Link>

                        <Link 
              to="/compromisos" 
              className={`nav-link ${isActiveLink('/compromisos') ? 'router-link-active' : ''}`}
            >
              Compromisos
            </Link>
            
            <Link 
              to="/contacto" 
              className={`nav-link ${isActiveLink('/contacto') ? 'router-link-active' : ''}`}
            >
              Contacto
            </Link>
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;